function normalizePath(path: string) {
  if (!path) return ''
  if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1)
  return path
}

export function isPathActive(currentPathname: string, route: string) {
  const current = normalizePath(currentPathname)
  const target = normalizePath(route)

  if (!target) return false
  if (current === target) return true
  return current.startsWith(`${target}/`)
}
